import http from "./http";

/* =========================
   GET ALL WOOD TYPES
========================= */
export const getWoodTypes = async () => {
  const res = await http.post(
    "wood_type_api",
    new URLSearchParams({ action: "get" }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return res.data;
};

/* =========================
   ADD WOOD TYPE
========================= */
export const addWoodType = async (payload) => {
  const res = await http.post(
    "wood_type_api",
    new URLSearchParams({
      action: "add",
      wood_type: payload.wood_type,
      kg: payload.kg,
      cet: payload.cet,
      remark: payload.remark,
    }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return res.data;
};

/* =========================
   UPDATE WOOD TYPE
========================= */
export const updateWoodType = async (id, payload) => {
  const res = await http.post(
    "wood_type_api",
    new URLSearchParams({
      action: "update",
      id: id,
      wood_type: payload.wood_type,
      kg: payload.kg,
      cet: payload.cet,
      remark: payload.remark,
    }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return res.data;
};

/* =========================
   DELETE WOOD TYPE
========================= */
export const deleteWoodType = async (id) => {
  const res = await http.post(
    "wood_type_api",
    new URLSearchParams({
      action: "delete",
      id: id,
    }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return res.data;
};
